import React from 'react';
import { Dropdown, Menu, Icon } from 'antd';

const MENU_KEY_ORG = '/organization';
const MENU_KEY_DASHBOARD = '/dashboard';

export default ({ collapsed, selectedKey, onChange }) => {
  const sectionLabel = selectedKey === MENU_KEY_ORG ? 'Organisation' : 'Plan';
  const overlay = (
    <Menu selectedKeys={[selectedKey]} onClick={onChange} className="menu-switch-dropdown">
      <Menu.Item key={MENU_KEY_ORG}>
        <Icon type="bank" aria-hidden />
        <span>Organisation</span>
      </Menu.Item>
      <Menu.Item key={MENU_KEY_DASHBOARD}>
        <Icon type="file-text" aria-hidden />
        <span>Plan</span>
      </Menu.Item>
    </Menu>
  );

  return collapsed ? (
    <Dropdown
      overlay={overlay}
      trigger={['click', 'hover']}
      placement="bottomRight"
      overlayClassName="menu-switch-dropdown-overlay"
    >
      <button
        type="button"
        className="menu-switch-collapsed-trigger"
        aria-label={`Switch side menu section, currently ${sectionLabel}`}
        aria-haspopup="menu"
      >
        <Icon type={selectedKey === MENU_KEY_ORG ? 'bank' : 'file-text'} aria-hidden />
      </button>
    </Dropdown>
  ) : (
    <nav aria-label="Side menu section">
      <Menu mode="horizontal" selectedKeys={[selectedKey]} onClick={onChange} className="menu-switch">
        <Menu.Item key={MENU_KEY_ORG}>
          <Icon type="bank" aria-hidden />
          Organisation
        </Menu.Item>
        <Menu.Item key={MENU_KEY_DASHBOARD}>
          <Icon type="file-text" aria-hidden />
          Plan
        </Menu.Item>
      </Menu>
    </nav>
  );
};
